import styles from './icons.module.scss';
import { useExtraClasses } from '@lib/hooks/useExtraClasses';

/**
 * Icon component
 *
 * @param props - The icon props
 * @param props.iconClass - The icon class name to render
 * @param props.externalStlyes - External css class name to add to the icon
 * @param props.extraClasses - Extra css classes to add to the icon
 * @param props.globalStyles - Global styles to add to the icon
 * @param alt - Alt text for the icon
 * @returns Specified icon JSX.Element
 *
 * @example
 * ```tsx
 * <Icons
 *  iconClass="telephone"
 *  externalStlyes={styles.other}
 *  extraClasses={['noMargin', 'hover']}
 *  alt="Icon alt text"
 * />
 * ```
 */
const Icons = ({
    iconClass,
    externalStlyes,
    extraClasses,
    globalStyles,
    alt,
}: {
    iconClass: string;
    externalStlyes?: string;
    extraClasses?: string[];
    globalStyles?: string;
    alt?: string;
}) => {
    // Hook to compute extra styles
    const extraClassString = useExtraClasses(extraClasses, styles);

    return (
        <i
            className={`${styles.bi} ${styles[`bi-${iconClass}`]} ${externalStlyes || ''} ${extraClassString} ${globalStyles || ''}`}
            title={alt ? alt : ''}
        ></i>
    );
};

export default Icons;
